// Main application controller
import { Diagram } from "./components/Diagram";
import { InfoPanel } from "./components/InfoPanel";
import { TitleOverlay } from "./components/TitleOverlay";
import { LocaleSwitcher } from "./components/LocaleSwitcher";
import { i18n } from "./utils/i18n";
import { appState } from "./utils/appState";

export class App {
  private diagram: Diagram | null = null;
  private infoPanel: InfoPanel | null = null;
  private titleOverlay: TitleOverlay | null = null;
  private localeSwitcher: LocaleSwitcher | null = null;

  async init(): Promise<void> {
    try {
      // Initialize i18n system
      await i18n.init();

      // Set initial locale in state
      appState.locale.set(i18n.getCurrentLocale());

      // Initialize components
      this.diagram = new Diagram(".diagram-container");
      this.infoPanel = new InfoPanel(".info-panel-container");
      this.titleOverlay = new TitleOverlay(".diagram-container");
      this.localeSwitcher = new LocaleSwitcher(".locale-switcher-container");

      // Initialize all components
      await this.diagram.init();
      this.infoPanel.init();
      this.titleOverlay.init();
      this.localeSwitcher.init();
    } catch (error) {
      this.showError();
    }
  }

  private showError(): void {
    const appElement = document.getElementById("app");
    if (appElement) {
      appElement.innerHTML = `
        <div style="text-align: center; padding: 2rem;">
          <h1>Failed to load application</h1>
          <p>Please refresh the page to try again.</p>
        </div>
      `;
    }
  }
}
